import { useSelector } from 'react-redux'
import { StateExtended } from '../../_config/interfaces/stateExtended'

export function useMenuToggleSelector() {
  const menuToggle = useSelector(
    (state: StateExtended) => state.menu.menuToggle,
  )
  return menuToggle
}